module.exports = __webpack_public_path__ + "static/media/profile-icon.8b90ae72.svg";